// i18n area 'common' — locale nl-NL (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/common.nl-NL.meta.json.
import type { enUS } from './common'

export const nlNL: typeof enUS = {
  nav: {
    home: 'Home',
    vms: 'Virtuele machines',
    templates: 'Templates',
    importVms: "VM's importeren",
    containers: 'Containers',
    containersApps: 'Apps',
    containersPods: 'Pods',
    containersCt: 'CT',
    multiscsi: 'TVStor MultiSCSI',
    containersOciImages: 'OCI-images',
    containersOciRegistries: 'OCI-registries',
    containersCtTemplates: 'CT-templates',
    networkServices: 'Netwerkdiensten',
    firewall: 'Firewall',
    checkpoints: 'Checkpoints',
    backup: 'Back-up',
    monitoring: 'Monitoring',
    cluster: 'Cluster',
    clusterSettings: 'Globale instellingen',
    clusterNodes: 'Nodes',
    clusterDevices: 'USB- en PCIe-resources',
    clusterFederation: 'Federatie',
    network: 'Netwerk',
    overlayNetworks: 'Overlaynetwerken',
    fabric: 'Fabric',
    ipam: 'IPAM',
    storage: 'Storage',
    data: 'Data',
    storages: 'Storage',
    hci: 'Hyperconvergentie',
    ceph: 'Ceph',
    system: 'Systeem',
    tasks: 'Tasks',
    events: 'Gebeurtenissen',
    audit: 'Audit',
    diagnostics: 'Diagnose',
    notifications: 'Meldingen',
    proximity: 'TVirt Proximity',
    users: 'Gebruikers en groepen',
    groups: 'Groepen',
    mfa: 'MFA',
    realms: 'Realms en SSO',
    rbac: 'Rollen en rechten',
    credentials: 'Credentials',
    scopes: 'Scopes',
    tags: 'Tags',
    explorer: 'Verkennen',
    licensing: 'Licentie',
    information: 'Informatie'
  },
  mode: {
    light: 'Licht',
    dark: 'Donker',
    system: 'Systeem',
    tooltip: 'Thema'
  },
  language: {
    tooltip: 'Taal'
  },
  langRegion: {
    europe: 'Europa',
    northAmerica: 'Noord-Amerika',
    southAmerica: 'Zuid-Amerika',
    asia: 'Azië'
  },
  notFound: {
    title: 'Pagina niet gevonden',
    body: 'Dit adres komt niet overeen met een TVirt-pagina — de pagina kan met een update verplaatst zijn, of de link is verouderd.',
    backHome: 'Terug naar Home'
  },
  scopeBrowser: {
    title: 'Scopes',
    all: 'Het hele cluster',
    noChildren: 'Hier zijn geen sub-scopes',
    recursive: 'Onderliggende meenemen',
    collapse: 'Scope-paneel inklappen',
    openPicker: 'Scopes verkennen',
    up: 'Eén niveau omhoog',
    countTooltip: '{direct} in deze scope · {total} inclusief onderliggende'
  },
  search: {
    tooltip: 'Zoeken (⌘K)',
    placeholder: "Zoek VM's, netwerken, storage…",
    empty: 'Geen resultaten',
    groups: {
      recent: 'Recent',
      shortcuts: 'Snelkoppelingen',
      actions: 'Acties',
      goTo: 'Ga naar'
    },
    kind: {
      catalog: 'Catalogus',
      scope: 'Scope',
      node: 'Node'
    },
    footer: {
      navigate: 'navigeren',
      open: 'openen',
      close: 'sluiten'
    },
    actions: {
      createVm: 'VM aanmaken…',
      uploadIso: 'ISO uploaden…',
      clusterSettings: 'Clusterinstellingen',
      consoleOf: 'Ga naar de console van {name}'
    }
  },
  stub: {
    containersSummary: "Applicaties en systeemcontainers (CT), met hun OCI-images, registries en templates — beheerd naast je VM's.",
    sectionSummary_vms: 'Virtuele machines en hun templates — levenscyclus, snapshots, migratie en consoles.',
    sectionSummary_storages: 'De storages waar disks, images en VM-metadata staan.',
    sectionSummary_catalogs: 'Het thuis van de bestandsartefacten van het cluster: ISO-images, CT- en VM-templates en OCI-archieven, geordend in catalogi.',
    sectionSummary_overlay: 'VXLAN-overlaynetwerken tussen de nodes van het cluster.',
    sectionSummary_fabric: "De inventaris van het fysieke netwerk — switches, poorten, LAGG's en logische netwerken.",
    sectionSummary_ipam: 'De adressering afgeleid van de fabric- en overlaynetwerken: wie welk adres in handen heeft.',
    sectionSummary_services: 'DHCP- en DNS-servers afgeleid van het netwerkregister.',
    sectionSummary_ceph: 'Beheerde Ceph-clusters op de TVirt-nodes.',
    sectionSummary_hci: 'De hyperconverged storage-technologieën op de TVirt-nodes.',
    sectionSummary_cluster: 'Nodes, lidmaatschap en clusterbrede instellingen.',
    containers: 'Systeemcontainers staan op de roadmap — deze sectie gaat ze herbergen.',
    containersApps: 'Gecontaineriseerde applicaties staan op de roadmap — dit gedeelte gaat ze herbergen.',
    containersPods: 'Pods groeperen containers die netwerk en volumes delen — de instanties zijn de apps.',
    containersCt: 'Systeemcontainers (CT) staan op de roadmap — dit gedeelte gaat ze herbergen.',
    multiscsi: 'TVStor MultiSCSI staat op de roadmap — dit gedeelte gaat het herbergen.',
    clusterFederation: 'Federatie tussen TVirt-clusters staat op de roadmap — dit gedeelte gaat het herbergen.',
    containersOciImages: 'OCI-images staan op de roadmap — dit gedeelte gaat ze herbergen.',
    containersOciRegistries: 'OCI-registries staan op de roadmap — dit gedeelte gaat ze herbergen.',
    containersCtTemplates: 'CT-templates staan op de roadmap — dit gedeelte gaat ze herbergen.',
    importVms: 'De importers voor ESXi en Proxmox komen hier: conversie van guests en migratie in bulk naar TVirt.',
    backup: 'Geïntegreerde back-up komt met 6.2: gededupliceerde content-addressed repositories, CBT-incrementals, immutability-vensters en repo-to-repo-replicatie.',
    monitoring: 'Clusterbrede dashboards voor contentie (cpu.ready, PSI-druk, ingebouwde alerts) komen eraan — vandaag staan dezelfde metrics in de details van elke VM.'
  },
  home: {
    welcome: 'Je bent ingelogd als: {name}',
    subtitle: 'Dit is je TVirt-cluster in één oogopslag.',
    loadError: 'Het overzicht kon niet worden geladen — is de TVirt-backend bereikbaar?',
    health: {
      ok: 'Alles in orde',
      warning: 'Let op',
      critical: 'Kritieke problemen'
    },
    reason: {
      'node-down': '{subject} is uitgeschakeld',
      'node-stale': '{subject} laat al even niets van zich horen',
      'node-maintenance': '{subject} in onderhoud',
      'tasks-failed': {
        one: '{n} mislukte task in de afgelopen 24 uur',
        other: '{n} mislukte tasks in de afgelopen 24 uur'
      },
      'storage-degraded': 'storage {subject} gedegradeerd',
      'storage-error': 'storage {subject} in foutstatus',
      'ceph-warning': 'Ceph {subject}: HEALTH_WARN',
      'ceph-error': 'Ceph {subject}: HEALTH_ERR',
      'store-unreachable': 'store van het cluster onbereikbaar',
      'license-absent': "geen licentie — nieuwe VM's kunnen niet starten",
      'license-expired': "licentie verlopen — nieuwe VM's kunnen niet starten",
      'license-exceeded': "licentielimiet overschreden — nieuwe VM's kunnen niet starten",
      'failover-reserve-eroded': 'failover-reserve bijna opgebruikt',
      'failover-reserve-exhausted': "failover-reserve uitgeput — nieuwe VM's kunnen niet starten",

      'oci-cache-nearly-full': 'OCI-cache op {subject} bijna vol — digests worden met de hand verwijderd',
      'oci-cache-full': 'OCI-cache op {subject} vol — geen enkele pull slaagt tot er digests verwijderd zijn',
      'config-replica-empty': 'configuratiereplica op {subject} is LEEG — de node heeft geen clusterconfiguratie tot een replicatie slaagt',
      'config-replica-stalled': 'configuratiereplicatie op {subject} staat stil — de lokale kopie loopt achter op de clusterconfiguratie'
    },
    staleChip: 'Gegevens niet actueel',
    staleAsOf: 'laatste replicatie {time}',
    zone: {
      nodes: 'Nodes',
      failoverReserve: 'Failover-reserve',
      capacity: 'Capaciteit',
      workload: 'Werklast',
      protection: 'Bescherming',
      activity: 'Recente activiteit'
    },

    // De zone van de failover-reserve (admission control N+1, task #133b).
    reserve: {
      state: {
        ok: 'Reserve intact',
        eroded: 'Reserve bijna opgebruikt',
        exhausted: 'Reserve uitgeput',
        unknown: 'Reserve onbekend'
      },
      tolerate: {
        one: 'verdraagt het verlies van {n} node',
        other: 'verdraagt het verlies van {n} nodes'
      },
      usedOf: '{used} / {allowed} GiB in gebruik',
      keepFree: '{n} GiB vrijgehouden voor failover',
      expendable: 'waarvan {n} opofferbaar in bedrijf',
      headroom: 'er kan nog {n} GiB worden gestart',
      short: "de reserve komt {n} GiB tekort — nieuwe VM's kunnen niet starten",
      hp: {
        usedOf: "Pagina's van {size} — in gebruik: {used} / {allowed}",
        keepFree: 'vrijgehouden voor failover: {keep}',
        headroom: 'nog te starten: {n}',
        short: "tekort in de reserve: {n} — nieuwe VM's met enorme pagina's kunnen niet starten"
      },
      worstCase: 'ergste geval: {nodes}',
      unavailable: '{node}: {reason}',
      unknown: 'Nog geen enkele node heeft zijn geheugen gemeld — de reserve is niet te berekenen en er wordt geen start geweigerd.',
      reason: {
        attestedDown: 'bevestigd uitgeschakeld',
        maintenance: 'in onderhoud',
        unreachable: 'onbereikbaar',
        capacityUnknown: 'geheugen niet gemeld'
      }
    },
    node: {
      cpu: '{n} CPU',
      cpuTopology: '{cores} cores / {threads} threads',
      memUsedOf: '{used} / {total} GiB',
      activeVms: {
        one: '{n} actieve VM',
        other: "{n} actieve VM's"
      },
      activeVmsUnknown: "actieve VM's onbekend",
      lastSeen: 'gezien {time}',
      neverSeen: 'nooit gezien',
      down: 'Uitgeschakeld',
      maintenance: 'Onderhoud',
      stale: 'Onbereikbaar'
    },
    capacity: {
      usedOf: '{used} / {total} GiB',
      provisioned: '{n} GiB geprovisioneerd',
      reserve: 'reserve {n} GiB',
      unobserved: 'capaciteit nog niet waargenomen',
      empty: 'Nog geen storage'
    },
    workload: {
      vms: 'Virtuele machines',
      apps: 'Apps',
      services: 'Netwerkdiensten',
      empty: 'Nog geen',
      phasesUnknown: 'verdeling per fase niet beschikbaar'
    },
    protection: {
      none: 'Nog geen backupbestemming geconfigureerd — bescherm je configuratie.',
      configure: 'Checkpoints configureren',
      noRuns: 'Er is nog geen checkpoint gemaakt.',
      last: 'Laatste checkpoint',
      onTarget: 'op {target}',
      viewAll: 'Checkpoints'
    },
    activity: {
      empty: 'Geen recente activiteit',
      failed24: {
        one: '{n} mislukt in 24 uur',
        other: '{n} mislukt in 24 uur'
      },
      viewAll: 'Alle tasks bekijken'
    }
  },
  notes: {
    title: 'Notities',
    tabEdit: 'Bewerken',
    tabPreview: 'Voorbeeld',
    placeholder: 'Vrije notities van de operator — Markdown wordt in het voorbeeld gerenderd',
    empty: 'Geen notities',
    tooLarge: 'De notities overschrijden de limiet van 64 KiB',
    saveError: 'Notities opslaan mislukt'
  },
  common: {
    contractError: 'Het antwoord van de backend bevat een waarde die deze interface niet kent: {field}={value} — werk de webinterface bij naar de versie van de backend.',
    contractErrorItems: '{count} objecten in deze lijst kunnen niet door deze interface worden gelezen ({field}={value}) en worden niet getoond.',
    staleHint: 'De store is niet bereikbaar — dit is de configreplica van deze node; de status van de fleet is onbekend.',
    staleStateAge: 'status per {time}',
    staleStateNever: 'status nooit ontvangen van de store: je ziet alleen de eigen waarnemingen van deze node',
    staleStateTooltip: 'De store van het cluster is niet bereikbaar: de waargenomen status (fase, node, agent) komt uit de statusreplica van deze node en dateert van de laatste geslaagde leesactie uit de store — hij kan verouderd zijn.',
    noPermission: 'Je hebt geen rechten voor deze actie',
    actionStillRunning: 'De actie loopt nog — de uitkomst is nog niet bekend',
    staleWrite: 'Iemand anders heeft dit object gewijzigd terwijl u het bewerkte — er is niets geschreven. Herlaad en herhaal uw wijziging op de actuele staat.',
    staleReload: 'Herladen',
    preview: 'Voorbeeld',
    previewTitle: 'Voorbeeld van het resultaat',
    previewNothingWritten: 'Gesimuleerd op de server — er is niets geschreven.',
    previewChanged: 'Gemarkeerd: de waarden die zouden veranderen.'
  },
  context: {
    copySelection: 'Geselecteerde tekst kopiëren'
  },
  crud: {
    create: 'Aanmaken',
    viewDetails: 'Details bekijken',
    viewOrEdit: 'Bekijken of bewerken',
    selected: 'geselecteerd',
    viewUsingVms: "VM's bekijken die deze resource gebruiken",
    clearSelection: 'Selectie wissen',
    deleteSelected: 'Geselecteerde verwijderen',
    bulkConfirmBody: {
      one: '{count} geselecteerd item verwijderen? Als het beschermd is, wordt het gemeld en behouden.',
      other: 'De {count} geselecteerde items verwijderen? Beschermde items worden gemeld en behouden.'
    },
    bulkDeleted: 'verwijderd',
    bulkRefused: 'geweigerd',
    fieldId: 'ID',
    createdAt: 'Aangemaakt op',
    updatedAt: 'Bijgewerkt op',
    immutableField: 'Vastgelegd bij het aanmaken — het contract staat wijziging niet toe',
    immutableScope: 'De scope wordt bij het aanmaken toegewezen; sommige resources verhuizen met een aparte actie',
    observedField: 'Waargenomen status — gemeld door het platform, niet bewerkbaar'
  }
}
